import webapp from '@/services/webapp'
import { useDeviceSettings } from '@/composables/settings'

export const useHapticFeedback = () => {
  const { gameDeviceSettings } = useDeviceSettings()

  function addHapticFeedback(style: 'light' | 'medium' | 'heavy' = 'heavy') {
    if (gameDeviceSettings.value.hapticFeedback) {
      webapp.hapticFeedbackImpact(style)
    }
  }

  function addNotificationFeedback(type: 'error' | 'success' | 'warning') {
    if (gameDeviceSettings.value.hapticFeedback) {
      webapp.hapticFeedbackNotification(type)
    }
  }

  function addSelectionFeedback() {
    if (gameDeviceSettings.value.hapticFeedback) {
      webapp.hapticFeedbackSelectionChanged()
    }
  }

  return {
    addHapticFeedback,
    addNotificationFeedback,
    addSelectionFeedback,
  }
}
